<div #menu class="menu">
  <audio-menu
    [animate.enter]="'menu-open'"
    [animate.leave]="'menu-close'"
  ></audio-menu>
</div>
<div class="border"></div>
<main #main>
  <div #mainHeader class="main-header">
    <div
      class="menu-toggle"
      tabindex="0"
      role="button"
      (click)="toggleMenu()"
      (keydown.enter)="toggleMenu()"
      [title]="$menuHidden() ? 'Afficher le menu' : 'Cacher le menu'"
    >
      <fa-icon [icon]="['fas', 'bars']"></fa-icon>
    </div>

    <audio-breadcrumb></audio-breadcrumb>

    <audio-theme-switcher></audio-theme-switcher>
  </div>
  <div #mainBody [class]="['main-body', $windowScrolled() ? 'scrolled' : '']">
    <router-outlet (activate)="scrollToTop()"></router-outlet>

    <button
      [class]="['scroll-top', $goToTop() ? 'clicked' : '']"
      (click)="scrollToTop()"
      aria-label="Retourner en haut"
    >
      <div><fa-icon [icon]="['fas', 'arrow-up']" /></div>
    </button>
  </div>
  <div #mainFooter class="main-footer"></div>
</main>
